import { Group, Table, Text } from '@melio/penny';
import { Collaborator } from '@melio/platform-api';

type Props = { collaborator: Collaborator<'user'> };
export const UserCell = ({ collaborator }: Props) => (
  <Table.Cell data-testid={`collaborators-table-row-${collaborator.id}-user-cell`}>
    <Group variant="vertical" spacing="none">
      <Group.Item>
        <Text textStyle="body3">
          <u>{`${collaborator.user.firstName} ${collaborator.user.lastName}`}</u>
        </Text>
      </Group.Item>
      <Group.Item>
        <Text textStyle="body4" color="neutral.darker">
          {collaborator.user.email}
        </Text>
      </Group.Item>
    </Group>
  </Table.Cell>
);
